export function formatCurrency(amount: number | string): string {
    const val = typeof amount === "string" ? parseFloat(amount) : amount;
    return val.toLocaleString('vi-VN', { style: 'currency', currency: 'VND', minimumFractionDigits: 0 , maximumFractionDigits: 0 });
}

export function formatDate(dateStr: string): string {
    const d = new Date(dateStr);
    return d.toLocaleDateString("vi-VN", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateTime(dateStr: string): string {
    const d = new Date(dateStr);
    return d.toLocaleString("vi-VN", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "long", year: "numeric" });
}

export function formatDateTimeParts(dateStr: string): { time: string; date: string } {
    const d = new Date(dateStr);
    return {
        time: d.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' }),
        date: d.toLocaleDateString('vi-VN'),
    };
}
